module.exports = __webpack_public_path__ + "static/media/icon-service-modulesB3.35e6c776.png";